import { createSelector } from '../../createSelector.js';

export const toastsSelector = createSelector('toasts.toasts');